import ExpirationChecklistItem from './ExpirationChecklistItem.component';

export default ExpirationChecklistItem;
